var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckIcon } from '@marketing-icons';
import { clsx } from 'clsx';
function ProductSelectorButton(_a) {
    var _b = _a.isSelected, isSelected = _b === void 0 ? false : _b, disabled = _a.disabled, _c = _a.label, label = _c === void 0 ? 'Product selector button' : _c, _d = _a.onClick, onClick = _d === void 0 ? function () {
        console.log('No onClick function provided');
    } : _d;
    var spacingAndSizing = 'w-full p-3 md:p-4';
    var backgroundColorStyle = clsx(isSelected ? 'bg-squash hover:bg-squash-100' : 'bg-shoe hover:bg-shoe-950');
    var textStyle = clsx(isSelected ? 'text-shoe hover:text-shoe' : 'text-bone hover:text-bone', 'text-sm-med-m md:text-xs-med-d disabled:text-state-inactive-dark');
    var disabledStyle = 'disabled:bg-bone-150 disabled:border-bone-150 disabled:text-bone-600 disabled:cursor-not-allowed';
    return (_jsx("button", __assign({ "aria-label": label, className: clsx('rounded-full w-full h-12 flex justify-center items-center border-2 tracking-tight border-shoe', spacingAndSizing, backgroundColorStyle, textStyle, disabledStyle), disabled: disabled, onClick: onClick }, { children: isSelected ? (_jsxs("div", __assign({ className: "flex justify-between items-center gap-3" }, { children: [_jsx(CheckIcon, { className: "text-icon-dark" }), "In your order"] }))) : ('Add to order') })));
}
export default ProductSelectorButton;
